import React from "react";

const Grupo3 = ({
    datos,
    handleChange,
    eliminarFila
}) => {

    return (

        <div>

            <div className="table-responsive">

                <table className="table align-middle">

                    <thead className="table-secondary">

                        <tr>

                            <th style={{ width: "45%" }}>
                                Proyecto
                            </th>

                            <th style={{ width: "170px" }}>
                                Personal requerido
                            </th>

                            <th style={{ width: "180px" }}>
                                Personal contratado
                            </th>

                            <th style={{ width: "150px" }}>
                                Indicador
                            </th>

                            <th style={{ width: "80px" }}>
                                Acción
                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {

                            datos.length === 0 &&

                            <tr>

                                <td
                                    colSpan={5}
                                    className="text-center"
                                >

                                    No hay registros. Presione "Agregar fila" para comenzar.

                                </td>

                            </tr>

                        }

                        {

                            datos.map((item, index) => (

                                <tr key={index}>

                                    <td>

                                        <input
                                            className="form-control"
                                            placeholder="Proyecto"
                                            value={item.proyecto || ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "proyecto",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.personal_requerido ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "personal_requerido",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            type="number"
                                            className="form-control"
                                            min="0"
                                            step="1"
                                            value={item.personal_contratado ?? ""}
                                            onChange={(e) =>
                                                handleChange(
                                                    index,
                                                    "personal_contratado",
                                                    e.target.value
                                                )
                                            }
                                        />

                                    </td>

                                    <td>

                                        <input
                                            className="form-control"
                                            value={`${item.indicador ?? 0}%`}
                                            readOnly
                                        />

                                    </td>

                                    <td className="text-center">

                                        <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() =>
                                                eliminarFila(index)
                                            }
                                        >

                                            <i className="bi bi-trash"></i>

                                        </button>

                                    </td>

                                </tr>

                            ))

                        }

                    </tbody>

                </table>

            </div>

        </div>

    );

};

export default Grupo3;